import type { NavSection } from '@pazportal/ui';

// Matches `.public-nav` (--public-ink) so the landing-page header continues
// as the sidebar once signed in. Fixed across light/dark like all portal colours.
export const PORTAL_COLOR = '#1F1E26';
export const PORTAL_NAME = 'PazNetworks, Inc.';
export const PORTAL_SUBTITLE = 'Customer Portal';

export const navSections: NavSection[] = [
  {
    label: 'Overview',
    items: [
      { label: 'Dashboard', href: '/dashboard' },
      { label: 'Locations', href: '/locations' },
      { label: 'Trends', href: '/trends' },
    ],
  },
  {
    label: 'Support',
    items: [
      // The open-ticket badge is computed live in AppLayout.
      { label: 'Tickets', href: '/tickets' },
      { label: 'Documents', href: '/documents' },
    ],
  },
  {
    label: 'Account',
    items: [
      { label: 'Billing', href: '/billing' },
    ],
  },
];

export function locationNavSections(locationId: string): NavSection[] {
  const base = `/locations/${locationId}`;
  return [
    {
      label: 'Site',
      items: [
        { label: 'Dashboard', href: base },
        { label: 'Trends', href: `${base}/trends` },
        { label: 'Network', href: `${base}/network` },
        { label: 'Services', href: `${base}/services` },
        { label: 'Systems', href: `${base}/systems` },
      ],
    },
    {
      label: 'Support',
      items: [
        { label: 'Tickets', href: `${base}/tickets` },
        { label: 'Documents', href: `${base}/documents` },
        { label: 'Reports', href: `${base}/reports` },
        { label: 'Activity', href: `${base}/activity` },
      ],
    },
    {
      label: 'Account',
      items: [
        { label: 'All locations', href: '/locations' },
        { label: 'Billing', href: '/billing' },
      ],
    },
  ];
}
